import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCollapseAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <mask
      id="a"
      width={16}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#999" d="M0 0h16v16H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#999"
        d="M8 11.25 5.233 14a.57.57 0 0 1-.416.183A.57.57 0 0 1 4.4 14a.57.57 0 0 1-.183-.417q0-.233.183-.416L7.15 10.4q.35-.35.85-.35t.85.35l2.75 2.767a.57.57 0 0 1 .184.416.57.57 0 0 1-.184.417.57.57 0 0 1-.416.183.57.57 0 0 1-.417-.183zm0-6.5L10.767 2a.57.57 0 0 1 .417-.183q.233 0 .416.183a.57.57 0 0 1 .184.417.57.57 0 0 1-.184.416L8.85 5.6q-.35.35-.85.35t-.85-.35L4.4 2.833a.57.57 0 0 1-.183-.416q0-.234.183-.417a.57.57 0 0 1 .417-.183q.233 0 .416.183z"
      />
    </g>
  </svg>
);
export default SvgCollapseAll;
